"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedUserResponse = void 0;
const date_util_1 = require("../../utils/date.util");
exports.mockedUserResponse = {
  id: 1,
  firstName: 'First',
  lastName: 'Last',
  email: 'email@email.com',
  auth0Id: null,
  amoId: null,
  lastLogin: date_util_1.takeDaysFromNow(),
  dateJoined: date_util_1.takeDaysFromNow()
};